import Service from '@/helpers/service'

export default {

    get(page, params) {
        return Service().get('LoadingGroup?page=' + page, {params});
    }, 
    show(id) {
        return Service().get('LoadingGroup/show/'+id);
    },    
    create(params) {
        return Service().post('LoadingGroup/create', params);
    },
    update(id, params) {
        return Service().post('LoadingGroup/update/'+id, params);
    },
    delete(id) {
        return Service().post('LoadingGroup/delete/'+id);
    }
}